import cx from 'classnames';
import { useBreakpoint } from '../../../../hooks';
import { PAGE_BREAKPOINTS } from '../../../../constants/commonConstants';
import { Conditional, WarningToolTip } from '../../../common';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatButton } from '@blocks-react/components/Button';
import { CatBadge } from '@blocks-react/components/Badge';
import { ServiceInsightHeadingProps } from '../../types';
import styles from './service-insight-heading.module.scss';

export const ServiceInsightHeading = ({
  serviceInsightTranslation,
  isNewCount,
  handleViewAllModal,
  isViewAllBtnEnable = false
}: ServiceInsightHeadingProps) => {
  const isDeskTop = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);

  return (
    <div
      className={`${styles['service-insight']} d-flex gap-2 pb-lg-3 pb-md-2`}
    >
      <CatHeading variant="title" tabIndex={0}>
        {serviceInsightTranslation.serviceInsightsLabel}
        <span className="d-inline-flex ms-2">
          <WarningToolTip
            isToolTip={false}
            toolTipHeading=""
            toolTipDescription=""
            tooltipHandler={() => null}
          />
        </span>
      </CatHeading>
      <div
        className={cx(
          'd-flex align-items-center',
          styles['service-insight__new-indicator'],
          {
            'justify-content-between': isNewCount && isViewAllBtnEnable
          },
          {
            'justify-content-end': !isNewCount && isViewAllBtnEnable
          }
        )}
      >
        <Conditional test={isNewCount}>
          <CatBadge
            className={styles['new-indicator']}
            text={serviceInsightTranslation.serviceInsightCountLabel}
            data-testid="serviceInsightNewBadge"
          />
        </Conditional>
        {isViewAllBtnEnable && !isDeskTop && (
          <CatButton
            className={styles['service-insight__view-all']}
            variant="ghost"
            size="sm"
            onClick={handleViewAllModal}
          >
            {serviceInsightTranslation.viewAllText}
          </CatButton>
        )}
      </div>
    </div>
  );
};
